__webpack_require__.p = "https://assets.worldcubeassociation.org/nextjs/b0a2ec36593f824e3903af8057b31d4e44825bf0/_next/";